import Vue from "vue";
import store from '@/store'
export default {
  install() {
    Vue.prototype.$profile = {

      // 
      // Get Profile
      //
      getProfile: async (id_user, endpoint) => {

        const params = {
          id_user: id_user,
        };

        try {
          const response = await requestApi(endpoint, params);
          const data = response.data;
          return data;
        } catch (error) {
          const err = error;
          throw err;
        }
      },


      // 
      // Request and show ProfileDrawer:  
      //
      showProfileDrawer: async (id_user, endpoint) => {

        // Handle Close (Se tentar abrir o mesmo já aberto ele fecha a dialog e reseta os dados)
        if (store.state.drawerProfile.open == true && store.state.drawerProfile.data.dados.id == id_user) {
          store.commit("showDrawerProfile", { open: false, data: { dados: { nome: '', login: '' } } });
          return;
        }

        // Logic Open:
        const data = await Vue.prototype.$profile.getProfile(id_user, endpoint);
        store.commit("showDrawerProfile", { open: true, data: data });

      },

    }
  }
}

// Constructor Request Api
const requestApi = (endpoint, params) => {
  store.commit("setFeedbackProgress", true);
  return new Promise((resolve, reject) => {
    Vue.prototype.$axios.post(`${endpoint}`,
      Vue.prototype.$formdata(params))
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      })
  });
};